import React, { Component } from 'react';
import { Container, Tabs, Tab, Button } from 'react-bootstrap';
import { FaPlus, FaTrash, FaPen, FaFileLines, FaToggleOn, FaToggleOff } from "react-icons/fa6";
import parse from 'html-react-parser';
import MenuLeftCMS from './ct-fragmentsidemenu';
import { GetText } from '../config/helper';
import '../config/global';
import CTNA from './ct-fragmentna';
import Popup from '../inc/PopUp';
import CTBannerForm from './ct-banner-form';
import CTBannerDetail from './ct-banner-detail';

const authKey = global.config.kindcode.training[21]+global.config.authBearerKey;


export default class CTBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activelink:"none",
      pageShow: '10',
      keyword: '',
      dataOri: {"ENG": [], "IDN": []},
      data: {"ENG": [], "IDN": []},
      stPopTitle: '',
      isOpen: false,
      otherContent: '',
      defTabIndex: "",
      usageFor: '',
      selectCategory: ""
    }
    this.loadContent = this.loadContent.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  togglePopClose() {
    this.setState( prevState => {
      return {  
          ...prevState.isOpen, isOpen: false,
      }
    })
  }  

  handleSelect = (e) => {
    const value = e.target.value;
    const inputname = e.target.name;
    var resFilterData = {
      "ENG": this.state.dataOri.ENG,
      "IDN": this.state.dataOri.IDN
    };
    if(inputname === "select_type") { 
        var resultID = this.state.dataOri.IDN;
        var resultEN = this.state.dataOri.ENG;
        if(value !== "") {
          resultID = resultID.filter((list) =>  {
            return list.content.bannerType === value;
          });
          resultEN = resultEN.filter((list2) =>  {
            return list2.content.bannerType === value; 
          });
        }
        
        resFilterData = {
          "ENG": resultEN,
          "IDN": resultID
        }
        
        this.setState( prevState => {
            return {  
                ...prevState.selectType, selectType: value,
                ...prevState.data, data: resFilterData
            }
        })
    } else if(inputname === "select_status") { 
      var result2ID = this.state.dataOri.IDN;
      var result2EN = this.state.dataOri.ENG;
      if(value !== "") {
        result2ID = result2ID.filter((listA) =>  {
          return listA.content.bannerStatus === value;
        });
        result2EN = result2EN.filter((list2A) =>  {
          return list2A.content.bannerStatus === value; 
        });
      }
      
      resFilterData = {
        "ENG": result2EN,
        "IDN": result2ID
      }
      
      this.setState( prevState => {
          return {  
              ...prevState.selectType, selectType: value,
              ...prevState.data, data: resFilterData
          }
      })
    } else {
        this.setState( prevState => {
            return {  
                ...prevState.pageShow, pageShow: value
            }
        })
    }
  }
  
  urladdBanner(param,action,currpage) {
    window.location.href=global.config.urlCms+"/"+currpage+'/add/'+param;
  }
  urlviewBanner(id,content,action) {
    var stPopTitle = action+" Banner Homepage ";
    var dataSend = {
      "banner_id": id,
      "banner_linkurl": content.bannerLinkurl,
      "banner_targeturl": content.bannerTargeturl,
      "banner_fileurl": content.bannerFileurl,
      "banner_filename": content.bannerFilename,
      "banner_filetype": content.bannerFiletype,
      "banner_type": content.bannerType,
      "banner_language": content.bannerLanguage,
      "banner_number": content.bannerNumber,
      "banner_status": content.bannerStatus,

    }
    this.setState( prevState => {
      return {  
        ...prevState.stPopTitle, stPopTitle: stPopTitle,  
        ...prevState.isOpen, isOpen: true,
        ...prevState.otherContent, otherContent : JSON.stringify(dataSend)
      }
    })
  }

  urlpublishBanner(valId,nextstat,param) {
    document.getElementById('loading-area').style.display = 'block';
    var datatext ='{"banner_status":"'+nextstat+'","banner_docid":"'+valId+'","form_id":"form-publish"}';
    var urlFetch = global.config.urlLink+"/banneredit";
    var data = JSON.parse(datatext);
    fetch(urlFetch, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
    }).then(res => {
        if(res.status === 200)
            return res.json() 
    }).then( resJson => {
        if(resJson.status === '200') {
            if(param === 'IDN') { param = "indonesia"; }
            else { param = "english"; }
            window.location.href=global.config.urlCms+"/"+this.state.activelink+"/"+param;
        } else {
            console.log('Something happened wrong');
        }
        document.getElementById('loading-area').style.display = 'none'; 
        if(resJson.status === '200') {
        } else {
            console.log('Something happened wrong');
        }
    }).catch(err => { 
        document.getElementById('loading-area').style.display = 'none'; 
    });
  }

  loadContent = (keyword,pageshow) => {
    return new Promise((resolve) => {
      var datatext ='{"keyword":"'+keyword+'","pageShow":"'+pageshow+'"}';
      var data = JSON.parse(datatext); 
      fetch(global.config.urlLink+"/bannerlist", {
          method: 'POST',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Authorization': authKey,
          }, body : JSON.stringify(data)
      }).then(response => {
          if(response.status === 200) {
              return response.json()
          } else {
              console.log('Something happened wrong');
          }
      }).then(resJson => {
          var resultList = resJson.values.sort((a, b) => a.content.bannerNumber - b.content.bannerNumber);
          var resultID = resultList.filter((list) =>  {
            return (list.content.bannerLanguage === "Indonesian" && (list.content.bannerStatus === global.config.bannerStatus[0] || list.content.bannerStatus === global.config.bannerStatus[1]));
          });
          var resultEN = resultList.filter((list2) =>  {
            return (list2.content.bannerLanguage === "English"  && (list2.content.bannerStatus === global.config.bannerStatus[0] || list2.content.bannerStatus === global.config.bannerStatus[1])); 
          });
          
          resolve({
            "ENG": resultEN,
            "IDN": resultID
          })
      }).catch(err => {
          resolve({"status": "500"});
      });
    });
  }

  async loadData () {
    var [result] = await Promise.all([this.loadContent(this.state.keyword,this.state.pageShow)]);
    this.setState({
            dataOri: result,
            data: result
        })
  }

  componentDidMount() {
    var urlpath = window.location.pathname;
    if(urlpath.substring(urlpath.length-1,urlpath.length) === "/") {
      urlpath = urlpath.substring(0,urlpath.length-1);
    }
    var arrUrl = urlpath.split("/");
    
    var tabKey="", tabKey2="";
    if(arrUrl.length===3 && arrUrl[arrUrl.length-1] !== "") {
      tabKey = arrUrl[arrUrl.length-1];
      tabKey2 = arrUrl[arrUrl.length];
    } else if(arrUrl.length===4 && arrUrl[arrUrl.length-1] !== "") {
        tabKey = arrUrl[arrUrl.length-2];
        tabKey2 = arrUrl[arrUrl.length-1];
    }
    
    var usageFor = 'english'
    var defindex = "tab-1";
    if(tabKey2 !== undefined && tabKey2 !== "" && tabKey2.toLowerCase() === "indonesia") { defindex = "tab-2"; usageFor = "indonesia"; }

    this.setState({
      activelink: tabKey,
      defTabIndex: defindex,
      usageFor: usageFor
    });
    this.loadData();
  }
  optionType(param) {
    var typeList = [];
    var typeData = global.config.bannerType;
    if(typeData.length > 0) {
        for(var r in typeData) {
          typeList.push(<option value={typeData[r].value}>{typeData[r].label}</option>)
        }
    }
    return typeList;
  }
  optionStatus(param) {
    var statusList = [];
    var statusData = [global.config.bannerStatus[0],global.config.bannerStatus[1]];
    if(statusData.length > 0) {
        for(var r in statusData) {
          statusList.push(<option value={statusData[r]}>{statusData[r]}</option>)
        }
    }
    return statusList;
  }
  contentTabs(param) {
    var statedata = this.state.data[param];
    var stLabel = "English Version"; if(param === 'IDN') { stLabel = "Indonesia Version"; }
    var bannerList = [];
    if(statedata.length > 0) {
      for(var ls=0; ls < statedata.length; ls++) {
          var retResult = statedata[ls];
          var editURL = global.config.urlCms+"/"+this.state.activelink+"/edit/"+retResult.docid;
          var iconPub = <FaToggleOff style={{color:"#999999"}} className="styleicons" onClick={this.urlpublishBanner.bind(this, retResult.docid, global.config.bannerStatus[0], param)}/>;
          if(retResult.content.bannerStatus === global.config.bannerStatus[0] ) { iconPub =  <FaToggleOn className="styleicons" onClick={this.urlpublishBanner.bind(this, retResult.docid, global.config.bannerStatus[1], param)}/> }

          bannerList.push(<tr key={retResult.docid}>
              <th scope="row-field" className="text-center">{ls+1}</th>
              <td><img src={retResult.content.bannerFileurl} border="0" width="250" /></td>
              <td>
                <span className="fw-bold">{retResult.content.bannerFilename}</span><br/>
                Link Url : {retResult.content.bannerLinkurl}<br/><br/>
                Position : Homepage - {retResult.content.bannerType}<br/>
                Status : {retResult.content.bannerStatus}
              </td>
              <td>
                  <a href={editURL}><FaPen className="styleicons" aria-label="edit" /></a>
                  <FaFileLines className="styleicons" aria-label="view" onClick={this.urlviewBanner.bind(this, retResult.docid, retResult.content, 'View')} />
                  {iconPub}
                  {retResult.content.bannerStatus !== global.config.bannerStatus[2] && <FaTrash className="styleicons" aria-label="delete" onClick={this.urlpublishBanner.bind(this, retResult.docid, global.config.bannerStatus[2], param)} /> }
              </td>
            </tr>)
        }
    } else {
      bannerList.push(<tr key="1">
            <th scope="row"></th>
            <td className="d-flex p-3">- no data -</td>
            <td></td>
            <td></td>
          </tr>)
    }
    
    
    return(<div>
              <div className="row show">
                  <div className="col-9">
                    <div className="d-flex">
                        <select name="select_type" className="form-control"
                                value={this.state.selectType} 
                                onChange={this.handleSelect}
                                ref={(input) => this.textInputType = input}
                            >
                            <option value="">-- All Position --</option>
                            {this.optionType(param)}
                        </select>
                        <select name="select_status" className="form-control ms-3"
                                value={this.state.selectStatus} 
                                onChange={this.handleSelect}
                                ref={(input) => this.textInputStatus = input}
                            >
                            <option value="">-- All Status --</option>
                            {this.optionStatus(param)}
                        </select>
                    </div>
                  </div>
                  <div className="col-3 d-flex justify-content-end">
                      <Button variant="secondary" size="sm" onClick={this.urladdBanner.bind(this, param.toLowerCase(),'Add',this.state.activelink)}><FaPlus style={{color:"#FFFFFF", size: "20px"}} className="me-2" />Add Banner</Button>
                  </div>
              </div>
              <div className="mt-3">
                  <table className="table">
                    <thead className="table-dark">
                      <tr key="0">
                      <th width="50" className="text-center" scope="col">#</th>
                      <th width="250" scope="col">Picture</th>
                      <th scope="col">Description</th>
                      <th width="150" scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                        {bannerList}
                    </tbody>
                  </table>
              </div>
           </div>
    )
    
  }  

  render() {
    return (
      <div className="setting">
       <Container>
      {
        (localStorage.getItem("ulvl") === global.config.userLevel[0] || localStorage.getItem("ulvl") === global.config.userLevel[2])? 
        (<>
          <div className="row py-5 mb-5">
            {/* === start - body */}
              <div className="col-md-3 bg-light">
                { 
                  this.state.activelink !== "none" && 
                    <MenuLeftCMS value={{tabkey:this.state.activelink}}/>
                
                }
              </div>
              <div className="col-md-9 p-4">
                <div className="row">
                  <div className="mb-4">
                    <h3>{GetText() ? "Pengaturan Banner" : "Banner Management"}</h3>
                    <span className="text-muted">{GetText() ? "Daftar Banner di Halaman Home Novaio" : "List of Banner in Homepage Novaio"}</span>
                  </div>
                  <div className="mt-3">
                    {
                    this.state.defTabIndex !== "" && 
                      <Tabs className="nav-scroll" defaultActiveKey={this.state.defTabIndex} variant="tabs" id="tab">
                        <Tab className="pt-4" eventKey="tab-1" title="English" key="1">
                          <div>
                          {this.contentTabs("ENG")}
                          </div>
                        </Tab>
                        <Tab className="pt-4" eventKey="tab-2" title="Indonesia" key="2">
                          {this.contentTabs("IDN")}
                        </Tab>

                      </Tabs>
                    }
                  </div>
                </div>
              </div>
            {/* === end - body */}
          </div>
          <div>
                {this.state.isOpen && <Popup
                  content={<><CTBannerDetail/></>}
                  title={this.state.stPopTitle}
                  others={this.state.otherContent}
                  styles={"70%"}
                  handleClose={this.togglePopClose.bind(this)}
                />}
          </div>
          </>
        )
      : 
        <div><CTNA/></div>
      }
      <div id="loading-area" className="d-none loading"></div> 
      </Container>
      </div>
    );
  }
}
